<div class="nt-export-warning" *ngIf="project && !project.enable_cookie_widget">
  <span *transloco="let t">
    {{ t('history.pdf_warning_start')
    }}<a (click)="print()">{{ t('test.export_as_pdf') }}</a
    >{{ t('history.pdf_warning_end') }}
  </span>
</div>
